import { render, staticRenderFns } from "./FormBrossure.vue?vue&type=template&id=92bfe0d0&"
import script from "./FormBrossure.vue?vue&type=script&lang=js&"
export * from "./FormBrossure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports